const ResourceCardSkeleton = () => {
  return (
    <div
      className="animate-pulse rounded-md border border-primary-ink-6 shadow-light backdrop-blur-25"
      aria-hidden="true">
      <div className="h-[200px] w-full rounded-t-md bg-secondary-gray-100" />

      <div className="bg-white/30 p-5 lg:px-5 lg:pb-5 lg:pt-4">
        <div className="min-h-[130px]">
          <div className="mb-4">
            <span className="inline-block h-[28px] w-20 rounded bg-secondary-gray-150" />
          </div>

          <div className="space-y-2">
            <div className="h-[22px] w-full rounded bg-secondary-gray-100" />
            <div className="h-[22px] w-3/4 rounded bg-secondary-gray-100" />
          </div>
        </div>

        <div className="mt-4 flex items-center gap-1.5">
          <div className="h-4 w-16 rounded bg-secondary-gray-100" />
          <div className="h-3 w-3 rounded bg-secondary-gray-100" />
        </div>
      </div>
    </div>
  )
}

export default ResourceCardSkeleton
